import { useSnapshotConsumer } from '@highlight/ipc/react'
import type { TrackedParticipant } from '@shared/types/meeting-participant'
import { meetingParticipantsConsumer } from '@renderer/services/meeting-participants-consumer'

export function useMeetingParticipants(): Record<number, TrackedParticipant> {
  return useSnapshotConsumer(meetingParticipantsConsumer).participants
}
